import {
  Flex,
  Input,
  InputGroup,
  SelectInput,
  SubheaderSkeleton,
  Widget,
} from '@revolut-internal/ui-kit'

export const QueueHealthPolicyThresholdSkeleton = () => (
  <Widget px="s-16" pb="s-16">
    <SubheaderSkeleton variant="nested">
      <SubheaderSkeleton.Title />
      <SubheaderSkeleton.Side />
    </SubheaderSkeleton>
    <InputGroup>
      <SelectInput options={[]} disabled />
      <Flex gap="s-8">
        <SelectInput options={[]} disabled />
        <Input width="42%" disabled />
      </Flex>

      <SelectInput options={[]} disabled />
    </InputGroup>
  </Widget>
)
